import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  Dialog: {
    backgroundColor: '#fff',

    '& h4': {
      color: '#545454',
      fontWeight: 'bold',
    },
  },
  dialogAction: {
    padding: '8px 24px',
    paddingBottom: 10,
    backgroundColor: '#fff',
  },
  root: {
    flexGrow: 1,

    '& .Mui-disabled': {
      backgroundColor: '#d5d5d5',
    },
  },
  formAdd: {
    backgroundColor: '#fff',

    '& span': {
      color: '#5a5a5a',
    },
    '& i': {
      color: '#4a90e2',
    },
  },
  GeoCode: {
    boxShadow: 'none',
    width: '100%',
    marginTop: 22,
    '& span': {
      color: '#fff',
      padding: 2,
    },
  },
  addBtn: {
    backgroundColor: '#cccccc',
    color: 'red',
  },
  closeBtn: {
    position: 'absolute',
    right: 20,
    top: 15,
    color: '#d8d8d8',
    fontSize: 30,
    cursor: 'pointer',
  },
}));
